import { mixed, object, string } from 'yup'
import { UserSalutationType } from '@saf/saf-kundenportal-frontend-api'
import {
  inputInvalid,
  invalidMailAddress,
  invalidPhoneNumber, invalidZip,
  mandatoryField,
} from '~shared/translations/yupSchemaErrors'
import { Step1ContactDetailsForm } from '@saf/saf-kundenportal-frontend-api/models/Step1ContactDetailsForm'

const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/
const zipRegExp = /^[0-9]{5}$/

export const Step1ContactDetailsSchema = object<Step1ContactDetailsForm>({
  salutation: mixed<UserSalutationType>().oneOf(Object.values(UserSalutationType), inputInvalid).required(mandatoryField),
  firstname: string().required(mandatoryField),
  lastname: string().required(mandatoryField),
  company: string().required(mandatoryField),
  streetAndNumber: string().required(mandatoryField),
  zip: string().required(mandatoryField).matches(zipRegExp, invalidZip),
  city: string().required(mandatoryField),
  email: string().required(mandatoryField).email(invalidMailAddress),
  phone: string().required(mandatoryField).matches(phoneRegExp, invalidPhoneNumber),
}).defined()
